<template>
  <div class="ca-cell-content" v-if="!!data && !!data.Id">
    <div v-if="data.HasSignIn">{{`出勤率：${data.AttendRateText}`}}</div>
    <div>{{`课程时长：${data.CourseMinutes}`}}</div>
    <div :class="BreakMinutesClass">
      {{`休息时长：${data.BreakMinutes}`}}</div>
    <div :class="TimestampStatusClass">
      {{`时间戳一致：${GLOBAL.timestampStatusType.getDesc(data.TimestampStatus)}`}}</div>
    <div :class="CameraStatusClass">
      {{`开启摄像头：${GLOBAL.cameraStatusType.getDesc(data.CameraStatus)}`}}</div>
    <div v-if="data.CourseActivationType == GLOBAL.enumCourseActivationType.EmailVideo" :class="SpeedupElementStatusClass">
      {{`有无速成元素：${GLOBAL.speedupElementStatusType.getDesc(data.SpeedupElementStatus)}`}}</div>
  </div>
</template>

<script>
const default_data = {
  Id: 0,
  CourseActivationType: 0,
  AttendRateText: "N/A",
  CourseMinutes: 0,
  BreakMinutes: 0,
  TimestampStatus: 0,
  CameraStatus: 0,
  SpeedupElementStatus: 0,
  HasSignIn: true,
};

export default {
  name: "courseActivationCell",
  props: {
    data: {
      type: Object,
      default: () => Object.clone(default_data),
    },
  },
  computed: {
    BreakMinutesClass() {
      let outValue = {};
      let caEntity = this.data;
      if (!caEntity) return outValue;

      outValue["cs-redLabel"] = caEntity.BreakMinutes > 10;

      return outValue;
    },
    TimestampStatusClass() {
      let outValue = {};
      let caEntity = this.data;
      if (!caEntity) return outValue;

      if (
        caEntity.CourseActivationType !==
        this.GLOBAL.enumCourseActivationType.EmailVideo
      ) {
        outValue["cs-redLabel"] =
          caEntity.TimestampStatus === this.GLOBAL.timestampStatusType.No;
      }

      return outValue;
    },
    CameraStatusClass() {
      let outValue = {};
      let caEntity = this.data;
      if (!caEntity) return outValue;

      if (
        caEntity.CourseActivationType ===
        this.GLOBAL.enumCourseActivationType.EmailVideo
      ) {
        outValue["cs-redLabel"] =
          caEntity.CameraStatus === this.GLOBAL.cameraStatusType.Yes;
      } else {
        outValue["cs-redLabel"] =
          caEntity.CameraStatus === this.GLOBAL.cameraStatusType.No;
      }

      return outValue;
    },
    SpeedupElementStatusClass() {
      let outValue = {};
      let caEntity = this.data;
      if (!caEntity) return outValue;

      if (
        caEntity.CourseActivationType ==
        this.GLOBAL.enumCourseActivationType.EmailVideo
      ) {
        outValue["cs-redLabel"] =
          caEntity.SpeedupElementStatus ==
          this.GLOBAL.speedupElementStatusType.Yes;
      }

      return outValue;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList4/courseActivationCell.vue